













































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentLiberarRepasseUnico extends Vue {
  loadLiberarRepasse: boolean = false

  get modalLiberarRepasseUnico() { return this.getFinanceiroStore.modal.liberarRepasseUnico }
  set modalLiberarRepasseUnico(value: boolean) { this.getFinanceiroStore.setModal({ name: 'liberarRepasseUnico', value }) }

  get loadingLiberarRepasses() { return this.loadLiberarRepasse }
  set loadingLiberarRepasses(value: boolean) { this.loadLiberarRepasse = value }

  async liberarRepasses() {
    this.loadingLiberarRepasses = true
    const response: any = await this.getFinanceiroStore.liberarRepasseUnico()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Repasse liberado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modalLiberarRepasseUnico = false
      // FXSR-2699 — o usuário continua na geração: recarrega a lista no lugar (itens, ações e dados
      // gerais) em vez de fechar a geração e voltar para a listagem.
      await this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse)
      this.getFinanceiroStore.getGeracaoRepasseAll()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao liberar o repasse.', icon: 'warning', color: '#C62828' })
    }
    this.loadingLiberarRepasses = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
